import i18n from 'i18n-js';

import { isEspagne } from 'common/config/env';

import esES from './locales/es-es';
import frFR from './locales/fr-fr';

import { AcceptedLocale, IntlShape, Options, Translate } from './types';

const AcceptedLocales: AcceptedLocale[] = ['es-ES', 'fr-FR'];

const DEFAULT_LOCALE: AcceptedLocale = isEspagne ? 'es-ES' : 'fr-FR';

const DEFAULT_OPTS: Options = {
  defaultLocale: DEFAULT_LOCALE,
  locale: DEFAULT_LOCALE,
};

const translate: Translate =
  (i18nTFunc: typeof i18n.t) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
  ): string => {
    const hasOptions = typeof args[args.length - 1] !== 'string';
    const keys: string[] = hasOptions ? args.slice(0, -1) : args;
    const options = args[args.length - 1];

    return i18nTFunc(keys.join('.'), options);
  };

export default function configure(opts?: Options): IntlShape {
  i18n.defaultLocale = opts?.defaultLocale || DEFAULT_OPTS.defaultLocale;
  i18n.locale = opts?.locale || DEFAULT_OPTS.locale;
  i18n.translations = { es: esES, fr: frFR };
  i18n.fallbacks = true;
  i18n.missingTranslation = () => undefined;

  const getCurrentLocale = () => i18n.locale;

  const setCurrentLocale = (locale: AcceptedLocale) => {
    i18n.locale = locale;
  };
  const t = translate(i18n.t);
  return {
    t,
    tt: t,
    l: i18n.l,
    acceptedLocales: AcceptedLocales,
    getCurrentLocale,
    setCurrentLocale,
  };
}
